import { render, staticRenderFns } from "./transactionAnchorComponent.vue?vue&type=template&id=0952e448&scoped=true"
import script from "./transactionAnchorComponent.vue?vue&type=script&lang=js"
export * from "./transactionAnchorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952e448",
  null
  
)

export default component.exports